import { DocumentImageDataWithTypeFromJSON as r, DocumentImageDataWithTypeToJSON as i } from "./DocumentImageDataWithType.js";
const u = {
  Passport: "PASSPORT",
  Cid: "CID",
  Ced: "CED",
  Cex: "CEX",
  Nit: "NIT",
  Rif: "RIF",
  Rut: "RUT",
  Curp: "CURP"
};
function a(e) {
  return !0;
}
function m(e) {
  return o(e);
}
function o(e, t) {
  return e == null ? e : {
    recordNumber: e.recordNumber == null ? void 0 : e.recordNumber,
    recordType: e.recordType == null ? void 0 : e.recordType,
    documentData: e.documentData == null ? void 0 : e.documentData,
    documentDataList: e.documentDataList == null ? void 0 : e.documentDataList.map(r),
    documentMimeType: e.documentMimeType == null ? void 0 : e.documentMimeType,
    expiryDate: e.expiryDate == null ? void 0 : new Date(e.expiryDate),
    issueDate: e.issueDate == null ? void 0 : new Date(e.issueDate)
  };
}
function c(e) {
  return n(e, !1);
}
function n(e, t = !1) {
  return e == null ? e : {
    recordNumber: e.recordNumber,
    recordType: e.recordType,
    documentData: e.documentData,
    documentDataList: e.documentDataList == null ? void 0 : e.documentDataList.map(i),
    documentMimeType: e.documentMimeType,
    expiryDate: e.expiryDate == null ? void 0 : e.expiryDate.toISOString(),
    issueDate: e.issueDate == null ? void 0 : e.issueDate.toISOString()
  };
}
export {
  m as PersonalIdFromJSON,
  o as PersonalIdFromJSONTyped,
  u as PersonalIdRecordTypeEnum,
  c as PersonalIdToJSON,
  n as PersonalIdToJSONTyped,
  a as instanceOfPersonalId
};
//# sourceMappingURL=PersonalId.js.map
